"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endEventTimer = exports.startEventTimer = exports.logEventDurationMetric = void 0;
var _a = require('./eventDurationLogger'), logEventDurationMetric = _a.logEventDurationMetric, startEventTimer = _a.startEventTimer, endEventTimer = _a.endEventTimer;
exports.logEventDurationMetric = logEventDurationMetric;
exports.startEventTimer = startEventTimer;
exports.endEventTimer = endEventTimer;
